import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'
import {HttpRequest} from '../Data/HttpRequest'
import * as OffsetLimit from '../Data/OffsetLimit'
import {DeliveryAddress} from '../Entities/DeliveryAddress'
import {Inquiry} from '../Entities/Inquiry'
import {InvoiceAddress} from '../Entities/InvoiceAddress'
import {OfferDraft} from '../Entities/OfferDraft'
import {PositionRow} from '../Pages/InquiryDetails/Offer/OfferState'

export function finish(
    id: number,
    data: { comment: string },
): HttpRequest {
    return {
        verb: 'PUT',
        url: `${server}/inquiries/${id}/finish`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(data)
    }
}

export function head(
    manufacturerId: number,
    inquiryNumber: number,
): HttpRequest {
    return {
        verb: 'HEAD',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/by-inquiry-number/${inquiryNumber}`,
        headers: {}
    }
}

export function list(
    manufacturerId: number,
    offsetLimit: OffsetLimit.OffsetLimit
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/inquiries/`,
                OffsetLimit.toQueryParameters(offsetLimit),
            ),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function updateOfferDraft(
    manufacturerId: number,
    inquiryNumber: number,
    offerDraft: OfferDraft,
): HttpRequest {
    return {
        verb: 'PUT',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/${inquiryNumber}/offer-draft`,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(offerDraft),
    }
}

export function updateOrderDraft(
    manufacturerId: number,
    inquiryNumber: number,
    invoiceAddressInput: InvoiceAddress,
    deliveryAddressInput: DeliveryAddress
): HttpRequest {
    return {
        verb: 'PUT',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/${inquiryNumber}/order-draft`,
        headers: {
            Accept: 'application/json',
        },
        body: JSON.stringify({
            deliveryAddress: deliveryAddressInput,
            invoiceAddress: invoiceAddressInput
        })
    }
}

export function retrieve(
    manufacturerId: number,
    inquiryNumber: number,
): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/by-inquiry-number/${inquiryNumber}`,
        headers: {
            Accept: 'application/json',
        },
    }
}

export function calculateShippingCosts(
    manufacturerId: number,
    inquiryNumber: number,
    positionRows: PositionRow[],
    inquiry: Inquiry
): HttpRequest {
    return {
        verb: 'POST',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/inquiries/${inquiry.id}/calculate-shipping-costs`, {}),
        headers: {
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            positionRows: positionRows,
            inquiry: inquiry
        })
    }
}

export function createOffer(
    manufacturerId: number,
    inquiryNumber: number,
    comment: string
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/${inquiryNumber}/offers`,
        headers: {
            Accept: 'application/json',
        },
        body: JSON.stringify({comment}),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/InquiryResource.ts